<template>
    <div style="height:100%">
        <el-row class="table-op">
            <template v-if="showSearch">
                <template v-for="fields in datadicInfo.fields">
                    <template v-if="fields.searchable">
                        <el-input v-if="fields.widgetType === 'SingleLineText'" v-model="listQuery[fields.name]" :key="fields.name" :placeholder="fields.label" :maxlength="fields.maxLength" :minlength="fields.minLength" size="mini" @change="onClickSearch" clearable />
                        <el-select v-else-if="fields.widgetType === 'DropdownSelect' " v-model="listQuery[fields.name]" size="mini" :key="fields.name" @change="onClickSearch" clearable :placeholder="fields.label">
                            <el-option :label="'请选择'+fields.label" key value></el-option>
                            <el-option v-for="o in fields.options" :key="o.value ||o.id" :label="o.name" :value="o.value || o.id"></el-option>
                        </el-select>
                        <!-- Date -->
                        <el-date-picker v-else-if="fields.widgetType === 'Date' " size="mini" v-model="listQuery[fields.name]" type="date" :key="fields.name" @change="onClickSearch" :placeholder="fields.label" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        <!-- DateTime -->
                        <el-date-picker v-else-if="fields.widgetType === 'DateTime' " size="mini" v-model="listQuery[fields.name]" type="datetime" :key="fields.name" @change="onClickSearch" :placeholder="fields.label"></el-date-picker>
                        <!-- Time -->
                        <el-time-picker v-else-if="fields.widgetType === 'Time' " size="mini" v-model="listQuery[fields.name]" @change="onClickSearch" :key="fields.name" :placeholder="fields.label"></el-time-picker>
                    </template>
                </template>
                <el-button v-if="datadicInfo.fields && datadicInfo.fields.length > 0 && searchableFieldsCount > 0" class="filter-item" type="default" plain icon="el-icon-search" @click="onClickSearch" size="mini"></el-button>
            </template>
            <el-button-group v-if="showOperationButtons">
                <el-button class="filter-item" type="default" plain icon="el-icon-plus" @click="onClickAdd" size="mini">添加{{this.datadicInfo.label}}</el-button>
                <el-button class="filter-item" type="default" plain icon="el-icon-delete" @click.native.prevent="onClickBatchRemove" size="mini">批量删除</el-button>
            </el-button-group>
        </el-row>

        <el-table v-loading="listLoading" row-key="id" :data="tableDatas" @selection-change="onSelectionChange" @current-change="onSingleSelect" class="b-table" highlight-current-row style="width: 100%;" size="mini" height="100%" stripe border>
            <el-table-column v-if="!singleSelection" type="selection" width="55" align="center"></el-table-column>
            <template v-for="field in showColumns">
                <template v-if="field.showInList">
                    <template v-if="field.widgetType == Constants.DataDic.WidgetType.YesOrNo">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name)" align="center">
                            <template slot-scope="{ row }">
                                <el-tag size="mini" type="danger" effect="dark" v-if="row[field.name] == false">否</el-tag>
                                <el-tag size="mini" type="success" effect="dark" v-if="row[field.name] == true">是</el-tag>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.SingleImageUpload">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name)">
                            <template slot-scope="{ row }">
                                <img :src="`/api/storage/resource/fileDownload?unique=${row[field.name]}&isAttachement=false`" />
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.DateTime">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '160px')" align="center">
                            <template slot-scope="{ row }">
                                {{Utils.formatDate(row[field.name], 'YYYY-MM-dd hh:mm:ss')}}
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.Date">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '100px')" align="center">
                            <template slot-scope="{ row }">
                                {{Utils.formatDate(row[field.name], 'YYYY-MM-dd')}}
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.Time">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '100px')" align="center">
                            <template slot-scope="{ row }">
                                {{Utils.formatDate(row[field.name], 'hh:mm:ss')}}
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="field.code && field.options && field.options.length > 0">
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '90px')" align="center">
                            <template slot-scope="{ row }">
                                {{getCodeOptionsValue(field, row)}}
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, field.widgetType == Constants.DataDic.WidgetType.Number ? '90' : '')">
                            <template slot-scope="{ row }">
                                <template v-if="field.isUnionColumn === true">
                                    {{getUnionColumnValue(field, row)}}
                                </template>
                                <template v-else>
                                    {{row[field.name]}}
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </template>
            </template>
            <template v-if="buttons && buttons.length > 0">
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="{ row }">
                        <template v-if="dropdownOperateButton">
                            <el-dropdown>
                                <el-button type="text" size="mini">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <template v-for="button in buttons">
                                        <template v-if="button === '-'">
                                            <el-dropdown-item :key="button.name" divided></el-dropdown-item>
                                        </template>
                                        <template v-else>
                                            <el-dropdown-item v-if="typeof button.canShow == 'undefined' || button.canShow(row)" :key="button.name">
                                                <div @click="() => {button.onClick(row)}">{{button.label}}</div>
                                            </el-dropdown-item>
                                        </template>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-else>
                            <template v-for="button in buttons">
                                <el-button :key="button.name" type="text" :loading="listLoading" size="mini" @click.native.prevent="button.onClick(row)">{{button.label}}</el-button>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </template>
            <template v-else>
                <el-table-column v-if="showOperationButtons" label="操作" width="100" align="center">
                    <template slot-scope="{ row }">
                        <template v-if="dropdownOperateButton">
                            <el-dropdown>
                                <el-button type="text" size="mini">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div @click.native.prevent="onClickEdit(row)">编辑</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div @click.native.prevent="onClickRemove(row)">删除</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-else>
                            <el-button type="text" :loading="listLoading" size="mini" @click.native.prevent="onClickEdit(row)">编辑</el-button>
                            <el-button type="text" :loading="listLoading" size="mini" @click.native.prevent="onClickRemove(row)">删除</el-button>
                        </template>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <div class="ta-c mt10" v-if="Utils.notNull(listQuery.rowCount) && listQuery.rowCount > 0">
            <el-pagination background layout="total, prev, pager, next,jumper" :total="listQuery.rowCount" :page-size="listQuery.pageSize" @current-change="loadTableDatas" :current-page.sync="listQuery.pageNo" :page-count="listQuery.totalPage"></el-pagination>
        </div>
    </div>
</template>
<script>
import DatadicAPI from "@/web-framework/api/datadic.js";
export default {
    name: "ListPage",
    props: {
        module: {
            type: String,
            default: '',
        },
        initQueryParams: {
            type: Object,
            default: () => {
                return {

                }
            }
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        buttons: {
            type: Array,
            default: null,
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dropdownOperateButton: {
            type: Boolean,
            default: false,
        },
        showOperationButtons: {
            type: Boolean,
            default: true
        },
        singleSelection: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            service: '',
            datadicName: '',
            datadicInfo: '',
            showColumns: [],
            listQuery: {
                pageNo: 1,
                pageSize: 20,
                orderby: 'createTime desc'
            },
            listLoading: false,
            tableDatas: [],
            selections: [],
            searchableFieldsCount: 0
        };
    },
    mounted() {
        let p = this.module.split('/');
        this.service = p[1];
        this.datadicName = p[2];
        if (this.initQueryParams) {
            this.listQuery = {
                ...this.listQuery,
                ...this.initQueryParams
            }
        }
        this.loadDatadic();
    },
    methods: {
        loadDatadic() {
            DatadicAPI.getDatadic(this.service, this.datadicName).then(result => {
                if (result.success) {
                    this.datadicInfo = result.data.datadicInfo;
                    this.createListQuery();
                    this.makeShownColumns();
                    this.loadTableDatas(1);
                }
            });
        },
        createListQuery() {
            if (this.datadicInfo && this.datadicInfo.fields) {
                this.datadicInfo.fields.forEach(item => {
                    if (item.searchable) {
                        Vue.set(this.listQuery, item.name, '');
                        this.searchableFieldsCount = this.searchableFieldsCount + 1;
                    }
                });
            }
        },
        makeShownColumns() {
            if (this.datadicInfo && this.datadicInfo.fields) {
                if (!this.columns || this.columns.length == 0) {
                    this.datadicInfo.fields.forEach(item => {
                        // 列表的列
                        if (item.showInList) {
                            this.showColumns.push(item);
                        }
                    });
                } else {
                    let map = this.Utils.list2map(this.datadicInfo.fields, 'name');
                    this.columns.forEach(item => {
                        let key = this.Utils.isString(item) ? item : item.key;
                        if (map[key]) {
                            this.showColumns.push(map[key]);
                        } else if (key.indexOf('/') != -1) {
                            let multi = key.split('/');
                            let p = [];
                            for (let i = 0; i < multi.length; i++) {
                                p.push(map[multi[i]].label);
                            }
                            let unionField = this.createUnionField(key, p.join('/'));
                            unionField.isUnionColumn = true;
                            unionField.unionColumn = multi;
                            unionField.showInList = true;
                            this.showColumns.push(unionField);
                        }
                    });
                }
            }
        },
        loadTableDatas(pageNo) {
            if (this.listQuery) {
                this.listQuery.pageNo = typeof pageNo == 'undefined' ? this.listQuery.pageNo : pageNo;
            }
            let params = this.Utils.convertEmptyString(this.listQuery);
            this.listLoading = true;
            Request.post(`${this.module}/search`, params).then(result => {
                this.listLoading = false;
                Request.validateResult(result, () => {
                    this.tableDatas = result.data ? result.data : [];
                    if (result.page) {
                        Vue.set(this.listQuery, 'rowCount', result.page.rowCount);
                        Vue.set(this.listQuery, 'totalPage', result.page.totalPage);
                    }
                });
            }).catch(error => {
                this.listLoading = false;
                Request.validateCatchError(error);
            });
        },
        /**
         * 查询过滤
         */
        onClickSearch() {
            this.loadTableDatas(1);
        },

        /**
         * 编辑角色
         */
        onClickEdit(row) {
            this.$emit('onClickEdit', row);
        },
        onClickRemove(row) {
            this.$confirm("确定要删除此条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.listLoading = true;
                Request.delete(`${this.module}/delete/${row.id}`).then(result => {
                    this.listLoading = false;
                    Request.validateResult(result, () => {
                        this.$message.success("删除成功！");
                        this.loadTableDatas();
                    });
                }).catch(error => {
                    this.listLoading = false;
                    Request.validateCatchError(error);
                });
            }).catch(error => {

            });
        },

        /**
         * 添加角色
         */
        onClickAdd() {
            this.$emit('onClickAdd');
        },

        /**
         * 多选事件
         */
        onSelectionChange(val) {
            this.selections = val;
        },
        onSingleSelect(val) {
            this.selections = [val];
        },
        /**
         * 批量删除
         */
        onClickBatchRemove() {
            if (this.selections.length == 0) {
                this.$message.error("请选择需要删除的分类");
                return;
            }
            this.$confirm("确定要删除选中的数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.listLoading = true;
                let idArray = this.selections.map(item => { return item.id });
                Request.post(`${this.module}/batchDelete`, idArray).then(result => {
                    this.listLoading = false;
                    Request.validateResult(result, () => {
                        this.$message.success("分类删除成功！");
                        this.loadTableDatas();
                    });
                }).catch(error => {
                    this.listLoading = false;
                    Request.validateCatchError(error);
                });
            }).catch(error => {

            });
        },
        refresh(pageNo) {
            this.loadTableDatas(pageNo);
        },
        getUnionColumnValue(field, row) {
            let columns = field.unionColumn;
            let p = [];
            for (let i = 0; i < columns.length; i++) {
                if (typeof row[columns[i]] != 'undefined') {
                    p.push(row[columns[i]]);
                }
            }
            if (p.length == 0)
                return "";
            else
                return p.join('/');
        },
        getCodeOptionsValue(field, row) {
            for (let i = 0; i < field.options.length; i++) {
                if (field.options[i].value == new String(row[field.name])) {
                    return field.options[i].name;
                } else if ((field.options[i].value == '1' && row[field.name] === true) || (field.options[i].value == '0' && row[field.name] === false)) {
                    return field.options[i].name;
                }
            }
            return '';
        },
        createUnionField(name, label) {
            return {
                name: name.replace('/', '_'),
                label: label,
                widgetType: 'SingleLineText'
            }
        },
        showLoading(showOrHide) {
            this.listLoading = showOrHide;
        },
        getIcon(button) {
        },
        getColumnKey() {
            let str = '';
            if (this.columns) {
                this.columns.forEach(item => {
                    if (this.Utils.isString(item)) {
                        str += item;
                    } else {
                        try {
                            str
                        } catch (error) {

                        }
                    }
                });
            }
        },
        // 获取当前所选择的项条目
        getSelections() {
            return this.selections;
        },
        // 获取列的宽度
        getColumnWidth(name, defaultValue) {
            if (this.columns && this.columns.length > 0) {
                for (let i = 0; i < this.columns.length; i++) {
                    if (!this.Utils.isString(this.columns[i]) && this.columns[i].key && this.columns[i].key == name) {
                        return this.columns[i].width;
                    }
                }
            }
            return this.Utils.isNull(defaultValue) ? 'auto' : defaultValue;
        }
    }
};
</script>
<style lang="less" scoped>
.table-search-container {
    /deep/.el-input {
        width: auto;
        min-width: 100px;
    }

    /deep/.el-date-editor,
    /deep/.el-input {
        margin-right: 6px;
    }
}
</style>